var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"auth-btn facebook-signin",on:{"click":function($event){return _vm.$emit('login', 'facebook')}}},[_c('span',{staticClass:"icon"}),_c('span',{staticClass:"text"},[_vm._v("Continue with Facebook")])])}
var staticRenderFns = []

export { render, staticRenderFns }